import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { signOut } from '../actions/auth'

export default function (ComposedComponent, checkAuthorization = true) {
    class Authorization extends Component {
        static contextTypes = {
            router: PropTypes.object
        }

        componentWillMount() {
            const url = this.props.match.path
            if (!this.props.user) {
                this.context.router.history.push(window.FOLDER + '/signin')
                this.props.signOut()
            } else {
                if (checkAuthorization) {
                    if (url !== `${window.FOLDER}/cambiar-contrasena`) {
                        if (!this.props.user.get('modulos').filter(x => x.get('modulos').filter(y => window.FOLDER + y.get('url') === url).count() > 0 || window.FOLDER + x.get('url') === url).count()) {
                            this.context.router.history.push(window.FOLDER + '/unauthorized')
                        }
                    }
                }
            }
        }

        componentWillUpdate(nextProps) {
            const url = this.props.match.path
            if (!nextProps.user) {
                this.context.router.history.push(window.FOLDER + '/signin')
                this.props.signOut()
            } else {
                if (checkAuthorization) {
                    if (url !== `${window.FOLDER}/cambiar-contrasena`) {
                        if (!nextProps.user.get('modulos').filter(x => x.get('modulos').filter(y =>  window.FOLDER + y.get('url') === url).count() > 0 ||  window.FOLDER + x.get('url') === url).count()) {
                            this.context.router.history.push(window.FOLDER + '/unauthorized')
                        }
                    }
                }
            }
        }

        render() {

            return <ComposedComponent {...this.props} />
        }
    }

    function mapStateToProps(state) {
        return {
            user: state.common.get('user'),
        }
    }

    const mapDispatchToProps = (dispatch) => {
        return {
            signOut: () => dispatch(signOut()),
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(Authorization)
}



// WEBPACK FOOTER //
// ./src/containers/Authorization.jsx